export default __webpack_public_path__ + "static/media/spinner_highres.4e68b1df.gif";